const convertBooleanValueToCharInArray = (propertyName: string, array: Array<any>, charIfTrue: string = "S", charIfFalse: string = "N") => {
	if(!array || array.length === 0 || !propertyName)
		return undefined;

	const propertyNameExistsInObject = propertyName in array[0];

	if(!propertyNameExistsInObject)
		return undefined;

	const newArray = array.map((arr) => ({
		...arr,
		[propertyName]: arr[propertyName] ? charIfTrue : charIfFalse
	}));

	return newArray;
};

export default convertBooleanValueToCharInArray;
